var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-dialer-common-popup",
    {
      staticClass: "app-dialer-call-members-popup",
      attrs: {
        title: _vm.title,
        "is-loading": _vm.isLoading,
        "is-disabled": _vm.isDisabled,
      },
      on: {
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "simplebar",
        { staticStyle: { width: "100%" } },
        _vm._l(_vm.members, function (member) {
          return _c("base-item", {
            key: member.memberId,
            attrs: {
              avatar: _vm.avatar,
              person: _vm.getPerson(member),
              title: _vm.getMemberName(member),
              description: _vm.getMemberIdentifierLabel(member),
              status: _vm.getMemberStatusLabel(member),
              "status-type": _vm.getMemberStatusType(member),
              actions: _vm.getMemberOptions(member),
              "show-action-icons": true,
              "is-disabled": _vm.isDisabled,
            },
            on: {
              "action-click": function ($event) {
                return _vm.onActionClick($event, member)
              },
            },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }